import React from 'react'
import myImage from '../components/assets/testpic.png';

const data = [
  { heading: 'Gujarat', points: ['NEET All India Test Series in Surat', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa'] },
  { heading: 'Maharashtra', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa'] },
  { heading: 'Uttar Pradesh (UP)', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa', 'NEET All India Test Series in Modasa'] },
  { heading: 'Karnataka', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Madhya Pradesh (MP)', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Bihar', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Haryana', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Assam', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Jharkhand', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Chhattisgarh', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Himachal Pradesh', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Tamil Nadu (TN)', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Jammu & Kashmir', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Uttarakhand', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
  { heading: 'Odisa', points: ['NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar', 'NEET All India Test Series in Jamnagar'] },
];

const Homepage = () => {
  return (
    <>

      {/* home-pannel1 */}

      <div className='home-pannel1'>
        <h2>Ace Your Ambitions with Shri Ji Institute (Total Victory) 2024</h2>
        <h1>All India Test Series</h1>
        <p>Join the Shri Ji Institute All India Test Series, the ultimate preparation platform for NEET, JEE, MHT-CET, MHT_NDA aspirants. Our meticulously crafted test series simulates real exam conditions, providing comprehensive assessments and detailed performance analyses. With Shri Ji Institute, transform your hard work into guaranteed success and secure your place in prestigious medical and engineering institutions.</p>
        <button>Click Here For NEET</button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button>Click Here For IIT-JEE</button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button>Click Here For MHT-CET</button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button>Click Here For MHT-NDA</button>
      </div>

      {/* home-pannel2 */}


      <div className='home-pannel2'>
        <p>Our previous results</p>
        <h1>SHRI JI INSTITUTE NEET AITS</h1>
        <div className='home-pannel2-img overflow-hidden'>
          <img src='https://theacademicjunction.co.in/wp-content/uploads/2022/08/Group-1-1.png'></img>
          <img src='https://theacademicjunction.co.in/wp-content/uploads/2022/08/Group-1-1.png'></img>
          <img src='https://theacademicjunction.co.in/wp-content/uploads/2022/08/Group-1-1.png '></img>
        </div>
      </div>

      {/* home-pannel3 */}

      <div className='home-pannel3-container'>
        <div className='top-content'>
          <h1 className='home-pannel3-top-heading'>Why Choose Us</h1>
          <p className='top-paragraph'>FEATURES</p>
        </div>
        <div className='home-pannel3-boxes-container'>
          <div className='home-pannel3-box'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTi_bkKaeKiLekqo3AhkqyGcIFQm1S0MB3Wt1nVysibqblwFu0KkhmAh6Biw8fLuEdlEQs&usqp=CAU' alt='Logo 1' className='box-logo' />
            <h2 className='home-pannel3-box-heading'>High-Quality Test Papers</h2>
            <p className='box-paragraph'>Crafted by expert faculties after rigorous analysis of the latest exam patterns.</p>
          </div>
          <div className='home-pannel3-box'>
            <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQv1-BB1NPs3Pr0KwYQ0Z2vS98ULMc04lyyK9CbuNYHDqJwSeALP45j210haOzeei1EcUs&usqp=CAU' alt='Logo 2' className='box-logo' />
            <h2 className='home-pannel3-box-heading'>Easy Enrollment Process</h2>
            <p className='box-paragraph'>A hassle-free registration process ensures you can start your preparation without any delays.</p>
          </div>
          <div className='home-pannel3-box'>
            <img src='data:image/png;base64,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' alt='Logo 3' className='box-logo' />
            <h2 className='home-pannel3-box-heading'>Real-Time Rank Analysis</h2>
            <p className='box-paragraph'>Experience the real-time stimulation of the NEET exam and gauge your preparation level.</p>
          </div>
          <div className='home-pannel3-box'>
            <img src='https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcSU05h1ijUzsFSUJMHJdAODep2jtWQYbn4CxtVCrUArXRTQO8Dt' alt='Logo 4' className='box-logo' />
            <h2 className='home-pannel3-box-heading'>Accessible Anytime, Anywhere</h2>
            <p className='box-paragraph'>Easily access the tests on your mobile device or laptop.</p>
          </div>
        </div>
      </div>

      {/* home-pannel4 */}

      <div className='home-pannel4-container'>
        <div className='top-content'>
          <h1 className='home-pannel4-top-heading'>our statistics</h1>
          <p className='top-paragraph'> SOME INTERESTING STATS</p>
        </div>
        <div className='home-pannel4-boxes-container'>
          <div className='home-pannel4-box'>
            <h2 className='home-pannel4-box-heading'>90,000+</h2>
            <p className='box-paragraph'>Over 90,000 students have benefited from our online and offline test centers with a high satisfaction rate.</p>
          </div>
          <div className='home-pannel4-box'>
            <h2 className='home-pannel4-box-heading'>75%</h2>
            <p className='box-paragraph'>Approximately 75% of questions in the actual NEET & JEE exams are reflected in our test papers, significantly increasing your chances of success.</p>
          </div>
          <div className='home-pannel4-box'>
            <h2 className='home-pannel4-box-heading'>51%</h2>
            <p className='box-paragraph'>About 51% of students who used our study materials and test papers have cleared the NEET & JEE exams in previous years.</p>
          </div>
          <div className='home-pannel4-box'>
            <h2 className='home-pannel4-box-heading'>225,000+</h2>
            <p className='box-paragraph'>We boast a vast database of 225,000 questions designed by industry experts after thorough research and analysis.</p>
          </div>
        </div>
      </div>

      {/* home-pannel5 */}

      <div className="home-pannel5-container">
        <div className="home-pannel5-top-content">
          <h1>ABOUT US</h1>
          <p>Welcome to Shri Ji Institute AITS, your trusted partner in achieving success in NEET and IIT-JEE exams. We are a dedicated team of educators and industry experts committed to providing high-quality test series and comprehensive study materials. Our All India Test Series (AITS) is designed to help students excel in their exams by offering meticulously curated test papers that mirror the latest NEET and JEE patterns.</p>
        </div>
        <div className="image-boxes">
          <div className="image-box">
            <img src="https://www.attaservices.com/img/our-mission2.jpg" alt="Image 1" />
            <div className="bottom-content">
              <h2>OUR MISSION</h2>
              <p>Our mission is to empower students to achieve their academic goals by providing them with the best possible preparation tools, offering expertly curated test series, comprehensive video solutions, easy accessibility, and real-time exam simulations, all within a supportive and motivating environment that guides students to success.</p>
            </div>
          </div>
          <div className="image-box">
            <img src="https://mukesharthrocare.com/wp-content/uploads/2020/08/v-630x408.jpeg" alt="Image 2" />
            <div className="bottom-content">
              <h2>OUR Vision</h2>
              <p>At Shri Ji Institute AITS, our vision is to become the leading provider of NEET and IIT-JEE preparation materials in India, continuously innovating and improving our test series based on the latest exam trends and student feedback, expanding our reach to make high-quality exam preparation accessible to all, and maintaining a high success rate by ensuring our test series remain highly reflective of the actual exam patterns.</p>
            </div>
          </div>
        </div>
      </div>

      {/* home-pannel6 */}

      <div className='home-pannel6-container'></div>

      <div className='home-pannel6-container'>
        <div className='home-pannel6-header-section'>
          <h1>TESTIMONIALS</h1>
          <p>Many students similar to you have trusted us and got success in previously held NEET examinations. We will definitely hold your hand and show the path for success to you.</p>
        </div>
        <div className='home-pannel6-boxes-container'>
          <div className='home-pannel6-box'>
            <h2>Nikunj B.</h2>
            <img src='https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTyWsQZA7cYi8YWxGA20cOfTmWkhuVwwP60aCS6xbVO-TL4IAXD' alt='Description of image 1' />
            <p>Best product for neet because it has good collection of questions which has required to practice for upcoming Neet exam</p>
          </div>
          <div className='home-pannel6-box'>
            <h2>Ankit Tiwari</h2>
            <img src='https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTyWsQZA7cYi8YWxGA20cOfTmWkhuVwwP60aCS6xbVO-TL4IAXD' alt='Description of image 2' />
            <p>There are 20 question papers provided which have sufficient questions to create an examination temperament all 3 section have questions which are at par with NEET-UG question paper design is also similar to the one that is in actual NEET.</p>
          </div>
          <div className='home-pannel6-box'>
            <h2>Prince Singh</h2>
            <img src='https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcTyWsQZA7cYi8YWxGA20cOfTmWkhuVwwP60aCS6xbVO-TL4IAXD' alt='Description of image 3' />
            <p>It is very much helpful for NEET aspirant to achieve maximum score. Most of the questions were asked from this test reries papers. So every students should buy this test series.</p>
          </div>
        </div>
      </div>

      {/* home-pannel7 */}

      <div className='home-pannel7-container'>
        <h1>OUR OFFLINE CENTERS FOR Shri Ji Institute</h1>
        <img src='https://aits.thinkiit.in/wp-content/uploads/2024/06/India-Map-with-Abhijay-Center-1024x785.webp' alt='Map of Abhijay Centers'></img>


        <div className='boxes-container'>
          {data.map((item, index) => (
            <div className='box' key={index}>
              <h2>{item.heading}</h2>
              <ul>
                {item.points.map((point, pointIndex) => (
                  <li key={pointIndex}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* home-pannel8 */}

      <div className="home-pannel8-container">
        <div className="home-pannel8-header-content">
          <h1>Don’t Take Just Our Word For It !</h1>
          <p>See yourself what our students have to say about us!</p>
        </div>
        <div className="home-pannel8-content-sections">
          <div className="home-pannel8-left-section">
            <h2>Analyse your progress</h2>
            <ul>
              <li>Curated by experts</li>
              <li>Based on Latest NEET Pattern</li>
              <li>Tests As Per Schdeule</li>
              <li>Video Solutions Available</li>
            </ul>
          </div>
          <div className="home-pannel8-right-section">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

      {/* home-pannel9 */}

      <div class="home-pannel9-container">
        <div class="home-pannel9-text-content">
          <p>Hand Written feedbacks</p>
          <h1>Hand written reviews</h1>
        </div>
        <div class="home-pannel9-image-grid">
          <div class="home-pannel9-image-box"><img src="https://aits.thinkiit.in/wp-content/uploads/2024/05/LATHIYA-DHAVAT-MUNESHBHAI-Testmonial-min-768x998-2.webp" alt="Image 1" /></div>
          <div class="home-pannel9-image-box"><img src="https://aits.thinkiit.in/wp-content/uploads/2024/05/KUNADIA-MEET-PRAKASHBHAI-Testimonial-min-768x602-1.webp" alt="Image 2" /></div>
          <div class="home-pannel9-image-box"><img src="https://aits.thinkiit.in/wp-content/uploads/2024/05/GOLAKIYA-KRISH-ASHOKBHAI-Testimonial-min-768x532-1.webp" alt="Image 3" /></div>
          <div class="home-pannel9-image-box"><img src="https://aits.thinkiit.in/wp-content/uploads/2024/05/BHIMANI-URVISH-NITESHBHAI-Testimonial-min-768x962-1.webp" alt="Image 4" /></div>
          <div class="home-pannel9-image-box"><img src="https://aits.thinkiit.in/wp-content/uploads/2024/05/LATHIYA-DHAVAT-MUNESHBHAI-Testmonial-min-768x998-1.webp" alt="Image 5" /></div>
          <div class="home-pannel9-image-box"><img src="https://aits.thinkiit.in/wp-content/uploads/2024/05/LATHIYA-FENIL-PRAKASHBHAI-Testimonial-min-768x882-1.webp" alt="Image 6" /></div>
        </div>
      </div>

      {/* home-pannel10 */}

      <div className='home-pannel10-container'>
        <p>for any queries use the below contact form</p>
        <h1>contact us</h1>
        <p>Send us your queries, we’ll get back to you within 24 hours</p>

        <form>
          <div className='form-group'>
            <label htmlFor='name'>Name:</label>
            <input type='text' id='name' name='name' required />
          </div>
          <div className='form-group'>
            <label htmlFor='city'>City:</label>
            <input type='text' id='city' name='city' required />
          </div>
          <div className='form-group'>
            <label htmlFor='email'>Email:</label>
            <input type='email' id='email' name='email' required />
          </div>
          <div className='form-group'>
            <label htmlFor='phone'>Phone Number:</label>
            <input type='tel' id='phone' name='phone' required />
          </div>
          <div className='form-group'>
            <label htmlFor='query'>Your Query:</label>
            <textarea id='query' name='query' rows='4' required></textarea>
          </div>
          <button type='submit'>Submit</button>
        </form>
      </div>

      {/* home-pannel11 */}

      <div className='home-pannel11-container'>
        <div className='home-pannel11-content'>
          <p className='home-pannel11-paragraph'>read our updates from blog</p>
          <h1 className='home-pannel11-heading'>latest news</h1>
          <div className='home-pannel11-image-box'>
            <img src={myImage} alt='Description of Image' />
          </div>
          <div className='home-pannel11-footer'>
            {/* <a href='thinkIIT-thinkNEET Shri Ji Institute All India Test Series: The Ultimate Guide to Cracking NEET 2024'>thinkIIT-thinkNEET Shri Ji Institute All India Test Series: The Ultimate Guide to Cracking NEET 2024</a> */}
            <p className='home-pannel11-date'>September 8, 2023</p>
          </div>
        </div>
      </div>

      {/* home-pannel12 */}

      <div className='home-pannel12-container'>
        <button className='home-pannel12-view-all-button'>View All Posts</button>
        <div className='home-pannel12-content-container'>
          <div className='home-pannel12-left-section'>
            <div className='home-pannel12-heading'>
              <h1>Shri Ji Institute AITS</h1>
            </div>
            <p>🏆 A Path to Excellence: Shri Ji Institute AITS (All India Test Series) is not just about preparing for exams; it’s about preparing for success. Join the ranks of high achievers who have used AITS as a stepping stone to their dreams.</p>
          </div>
          <div className='home-pannel12-right-section'>
            <h2>PROGRAMS</h2>
            <ul className='home-pannel12-links-list'>
              <li><a href='#'>Shri Ji Institute AITS For NEET</a></li>
              <li><a href='#'>Shri Ji Institute AITS For JEE</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* home-pannel13 */}



    </>
  )
}

export default Homepage